<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-toolbar color="primary">GSPT Query</mat-toolbar>
<div class="dash-gis-gspt-container" fxLayout="column" fxLayoutAlign="space-between start">
    <form [formGroup]="gsptForm" (ngSubmit)="doTrace()">
        <div fxLayout="column">
            <mat-form-field>
                <input matInput
                       placeholder="Distance (Leave blank for maximum)"
                       name="distance"
                       formControlName="distance">
            </mat-form-field>
            <mat-radio-group formControlName="direction" fxLayout="column">
                <mat-radio-button value="up">Upstream</mat-radio-button>
                <mat-radio-button value="down">Downstream</mat-radio-button>
            </mat-radio-group>
            <div *ngIf="gsptForm.controls['direction'].invalid && (gsptForm.controls['direction'].dirty || gsptForm.controls['direction'].touched)"
                 class="alert alert-danger">
                <div *ngIf="gsptForm.controls['direction'].errors.required">You must choose a direction.</div>
            </div>
        </div>

        <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
            <button mat-button type="submit" [disabled]="gsptForm.invalid">Trace</button>
            <button mat-button type="cancel" (click)="cancel()">Cancel</button>
        </mat-dialog-actions>
    </form>
</div>
